/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface S2WGame
 */
export interface S2WGame {
    /**
     * Theme to use for the game
     * @type {string}
     * @memberof S2WGame
     */
    theme: string;
    /**
     * 
     * @type {number}
     * @memberof S2WGame
     */
    wheelTextLimit: number;
    /**
     * 
     * @type {number}
     * @memberof S2WGame
     */
    promoTextLimit: number;
    /**
     * Hard limit on the number of times a single player can play this spin to win game per day. This can be
     * null/undefined if there is no limit.
     * @type {number}
     * @memberof S2WGame
     */
    dailySpinLimit?: number | null;
    /**
     * The cost in points to spin the wheel
     * @type {number}
     * @memberof S2WGame
     */
    pointCost: number;
    /**
     * 
     * @type {string}
     * @memberof S2WGame
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof S2WGame
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof S2WGame
     */
    id: string;
}

/**
 * Check if a given object implements the S2WGame interface.
 */
export function instanceOfS2WGame(value: object): value is S2WGame {
    if (!('theme' in value) || value['theme'] === undefined) return false;
    if (!('wheelTextLimit' in value) || value['wheelTextLimit'] === undefined) return false;
    if (!('promoTextLimit' in value) || value['promoTextLimit'] === undefined) return false;
    if (!('pointCost' in value) || value['pointCost'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function S2WGameFromJSON(json: any): S2WGame {
    return S2WGameFromJSONTyped(json, false);
}

export function S2WGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): S2WGame {
    if (json == null) {
        return json;
    }
    return {
        
        'theme': json['theme'],
        'wheelTextLimit': json['wheelTextLimit'],
        'promoTextLimit': json['promoTextLimit'],
        'dailySpinLimit': json['dailySpinLimit'] == null ? undefined : json['dailySpinLimit'],
        'pointCost': json['pointCost'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function S2WGameToJSON(value?: S2WGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'theme': value['theme'],
        'wheelTextLimit': value['wheelTextLimit'],
        'promoTextLimit': value['promoTextLimit'],
        'dailySpinLimit': value['dailySpinLimit'],
        'pointCost': value['pointCost'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

